import {FUINavigationLink} from "../../navigation-link/navigation-link.model";
import {FUIIcon} from "../../../icons/icon/icon.model";

export class FUINavigationBranch {
    public title: string;
    public links: FUINavigationLink[];
    public icon: FUIIcon;

    constructor(object?: any) {
        this.title = object && object.title || null;
        this.links = object && object.links && object.links.map(link => new FUINavigationLink(link)) || null;
        this.icon = object && new FUIIcon(object.icon) || new FUIIcon();
    }
}
